export default __webpack_public_path__ + "static/media/taki-lunch.2eaaeb81.gif";